
<template>
  <div class="content-list">
    <exam-header :canClickLogo="true"></exam-header>
    <main class="content-list_main">
      <div class="content-list_hd"  v-if="!isVisitor">
        <img class="fit-img" src="@/common/images/student/bg_paper_hd.png" alt="">
        <div class="history-btn" @click="goHistory('exam')"><span/>我的考试记录</div>
      </div>
      <div class="content-list_content">
        <div class="quiz-list" v-if="!isVisitor">
          <a class="quiz-card" href="/paperList" target="_blank">
            <img src="@/common/images/student/img_test.png" class="quiz-card_img" />
            <div class="quiz-card_title">少年班培养测评</div>
            <button class="button">前往测试</button>
          </a>
        </div>
        <div class="course-list"
          :class="isVisitor ? 'course-list_visitor' : 'course-list_student'"
          >
          <h3
            class="course-list_title"
            >示范班课程</h3>
          <div class="course-list_desc" v-if="isVisitor">
            <p>杰出少年示范数学班课程 免费学</p>
            <!-- <div class="history-btn" @click="goHistory('study')"><span/>我的学习记录</div> -->
          </div>
          <div class="course-list_items">
            <a
              class="course-card-warp"
              v-for="(course, index) in courseData"
              :key="index"
              :href="`/courseDetail?libraryId=${course.bookLibraryId}`"
            >
              <div class="course-card">
                <div class="free-tag"></div>
                <div class="card-content">
                  <div class="course-cover">
                    <img :src="course.cardImgUrl" class="fit-img"/>
                  </div>
                  <div class="course-info">
                    <h3 class="course-name" >{{ course.title }}</h3>
                    <p class="course-teacher">授课老师: {{ course.teacher }}</p>
                    <div class="card-footer">
                      <div  class="view-course-btn">立即学习</div>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>

      </div>
    </main>
  </div>
</template>
<script>

import {defineComponent} from "vue";
import ExamHeader from "@/components/examHeader.vue";
import {getUser} from "@/api/user";
import {getContentList} from "@/api/courseData"

export default defineComponent({
  components: {ExamHeader},
  data() {
    return {
      userIdentity:null,
      isVisitor:false,
      courseData:[]
    }
  },
  methods: {
    getCourseList(){
      getContentList().then((res) => {
        if (res.code === 200 && res.body?.contents) {
          this.courseData = res.body.contents;
        }
      })
    },
    goHistory(tab) {
      this.$router.push({
        name:'historyDetail',
        query:{
          tab
        }
      })
    },
    checkUser() {
      getUser().then((res) => {
        if(!res || !res.roles || res.roles.length === 0 || res.roles.findIndex(role => role === 'STUDENT') === -1) {
          this.isVisitor = true;
        }
        // this.userIdentity = res;
      })
    },
  },
  mounted() {
    this.checkUser();
    this.getCourseList();
  },
})
</script>
<style scoped lang="less">
.content-list{
  background: #EDE4DA;
  min-height: 100%;
  padding-top: 96px;
  padding-bottom: 56px;
  box-sizing: border-box;
  &_main{
    width: 1200px;
    border-radius: 20px;
    margin: 0 auto;
    background-color: #fff;
    min-height: calc(100vh - 160px);
    box-sizing: border-box;
  }
  &_hd{
    position: relative;
    height: 100px;
    border-radius: 20px 20px 0 0;
    overflow: hidden;
    background: #FFFFFF;
    .history-btn{
      position: absolute;
      right: 48px;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
      width: 136px;
      height: 32px;
      background:#F5F6F9;
      font-size: 14px;
      border-radius: 8px;
      cursor: pointer;
      span{
        width: 15px;
        height: 15px;
        margin-right: 5px;
        background: url("@/common/images/ic_history.png") center / contain no-repeat;
      }
    }
  }
  &_content{
    padding: 30px 40px;
    text-align: left;
    .quiz-list {
      margin-bottom: 36px;
      .quiz-card {
        display: flex;
        align-items: center;
        background: #F2E9DF;
        border-radius: 24px;
        padding: 12px 36px 12px 24px;
        &_img {
          height: 120px;
          margin-right: 20px;
        }
        &_title {
          font-size: 24px;
          font-weight: 600;
          color: #1D2129;
        }
        .button {
          width: 110px;
          height: 40px;
          margin-left: auto;
          font-size: 14px;
          &:hover {
            background: #C5111F;
          }
        }
      }
    }
    .course-list{
      &.course-list_student {
        .course-list_title {
          font-size: 24px;
          font-weight: 500;
        }
        .course-list_items {
          margin-top: 20px;
        }
      }
      &_title{
        color: #000000E5;
        font-weight: 600;
        font-size: 32px;
      }
      &_desc{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;
        p{
          color: #4E5969;
          font-size: 20px;
        }
        .history-btn{
          display: flex;
          align-items: center;
          justify-content: center;
          width: 144px;
          height: 36px;
          background:#F2F3F5;
          font-size: 14px;
          border-radius: 90px;
          cursor: pointer;
          color: #000000;
          span{
            width: 15px;
            height: 15px;
            margin-right: 5px;
            background: url("@/common/images/ic_history.png") center / contain no-repeat;
          }
        }
      }
      &_items {
        margin-top: 40px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 28px;
        .course-card-warp {
          width: calc((100% - 84px) / 4);
          margin-right: 0;
          flex-shrink: 0;
          display: block;
        }
        .course-card {
          width: 100%;
          // height: 100%;
          overflow: hidden;
          background: #FFFFFF;
          display: flex;
          flex-direction: column;
          position: relative;
          &:hover{
            .course-cover .fit-img{
              transform: scale(1.1);
            }
          }
          .course-cover {
            width: 100%;
            height: 173px;
            border-radius: 20px 20px 0 0;
            overflow: hidden;
            .fit-img {
              transition: all 0.3s ease-in-out;
            }
          }
          .free-tag {
            position: absolute;
            width: 51px;
            height: 26px;
            background: url("@/common/images/student/ic_free.png") no-repeat center center;
            background-size: 100% 100%;
            top: 19px;
            left: 0;
            z-index: 2;
          }
          .card-content {
            position: relative;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            .course-info {
              background: #FFFFFF;
              width: 100%;
              box-sizing: border-box;
              padding: 16px 20px 28px;
              border: 1px solid #DBDBDB;
              border-radius: 0 0 20px 24px;
              border-top: none;
              text-align: left;
              .course-name {
                font-size: 20px;
                margin-bottom: 2px;
                color: #000000E5;
                font-weight: 500;
                line-height: 1.5;
              }
              .course-teacher {
                font-size: 14px;
                color: #4E5969;
              }
            }
          }

          .card-footer {
            margin-top: 14px;
            .view-course-btn {
              display: block;
              text-align: center;
              width: 100%;
              height: 44px;
              line-height: 44px;
              background: #E60012;
              color: #FFFFFF;
              border: none;
              border-radius: 24px;
              font-size: 14px;
              font-weight: 500;
              cursor: pointer;
              transition: background 0.3s ease;
              user-select: none;
              &:hover {
                background: #C5111F;
              }
              &:active {
                background: #B0121A;
              }
            }
          }
        }
      }
    }
  }
}
.fit-img{
  width: 100%;
}
</style>